
import React from 'react';
import update from 'immutability-helper';
import { compose, withState, withHandlers } from 'recompose';
import { hot } from 'react-hot-loader';
import { Segment, Form, Label } from 'semantic-ui-react';
import debounceHandler from '@hocs/debounce-handler';

import { withLocale } from 'op/components/locale';

export const withReportFeedback = compose(
	withState('remarks', 'setRemarks', ({ report }) => report.remarks),
	debounceHandler('invokeChange', 500, true),
	withHandlers({
		handleChange: ({ invokeChange, remarks, setRemarks }) => (field, value) => {
			const nextRemarks = update(remarks, { [field]: { $set: value } });  

			setRemarks(nextRemarks);
			invokeChange({ remarks: { $set: remarks } });
		},
		validateChange: ({ remarks, invokeChange }) => 
			() => invokeChange({ remarks: { $set: remarks } }),
	}),
);

const ReportFeeback = ({
	locale, readOnly, remarks, handleChange, validateChange 
}) => (
	<Segment>
		<Label size='large'> { locale.feedback_and_general_remarks } </Label>
		<Form.TextArea
			value={ remarks.general || '' }
			readOnly={!!readOnly}
			onBlur={ validateChange }
			onChange={ (e) => handleChange('general', e.target.value) } />

		<Label size='large'> { locale.non_complient_follow_up_actions } </Label>
		<Form.TextArea
			value={ remarks.followup || '' }
			readOnly={!!readOnly}
			onBlur={ validateChange }
			onChange={ (e) => handleChange('followup', e.target.value) } />

		<Label size='large'> { locale.employees_comment } </Label>
		<Form.TextArea
			value={ remarks.employee || '' }
			readOnly={!!readOnly}
			onBlur={ validateChange }
			onChange={ (e) => handleChange('employee', e.target.value) } />

		<Label size='large'> { remarks.isAus?"Comments on Assessment Process (Optional)":  locale.type_and_place } </Label>
		<Form.TextArea
			value={ remarks.type || '' }
			readOnly={!!readOnly}
			onBlur={ validateChange }
			onChange={ (e) => handleChange('type', e.target.value) } />
	</Segment>
);

export default compose(
	withLocale('report.feedback'),
	withReportFeedback,
	hot(module),
)(ReportFeeback);


